// 技能交換市集地圖攤位資料（先寫死，之後有 API 再替換）
// 座標基準：map_frame.png 原始尺寸 1101 x 792（px），[x1, y1, x2, y2]

const REGION_COLORS = {
  R1: '#52BEBE',
  R2: '#595758',
  R3: '#ED832F',
  R4: '#F6BF5A',
  R5: '#8AC889',
}

const MAP_IMAGE_WIDTH = 1101
const MAP_IMAGE_HEIGHT = 792

// 熱區與相鄰色塊之間的統一間距（原圖 px 基準，四邊各內縮一半）
const BOOTH_GAP = 6

// code: 分類代碼／fullName: 攤位全稱／fullTitle: 攤位詳細內容／shortTitle: 攤位簡稱／mapLabel: 地圖色塊上顯示的斷行文字（僅供地圖顯示用，不影響 shortTitle）
const rawBooths = [
  { code: 'R1-1', box: [904, 570, 1010, 676], fullName: 'R1接待實務1', fullTitle: '照客罩得住：零漏接的全面守護', shortTitle: '照客罩得住', mapLabel: '照客罩得住' },
  { code: 'R1-2', box: [796, 570, 902, 676], fullName: 'R1接待實務2', fullTitle: '智能報到與出單整合系統', shortTitle: '智能報到與出單整合系統', mapLabel: '智能報到與出單整合系統' },
  { code: 'R1-3', box: [648, 570, 754, 676], fullName: 'R1接待實務3', fullTitle: '照客培訓工作坊', shortTitle: '照客培訓工作坊', mapLabel: '照客培訓工作坊' },
  { code: 'R1-4', box: [539, 570, 646, 676], fullName: 'R1接待實務4', fullTitle: '物管系統與福慧系統', shortTitle: '物管系統與福慧系統', mapLabel: '物管系統與福慧系統' },
  { code: 'R1-5', box: [394, 570, 500, 676], fullName: 'R1接待實務5', fullTitle: '精舍緊急事件處理應變SOP', shortTitle: '精舍緊急事件處理應變SOP', mapLabel: '精舍緊急事件處理應變SOP' },

  { code: 'R2-1', box: [284, 570, 392, 676], fullName: 'R2行政實務1', fullTitle: '香積組作業流程', shortTitle: '香積組作業流程', mapLabel: '香積組作業流程' },
  { code: 'R2-2', box: [105, 570, 213, 676], fullName: 'R2行政實務2', fullTitle: '菜單開立', shortTitle: '菜單開立', mapLabel: '菜單開立' },
  { code: 'R2-3', box: [105, 379, 213, 485], fullName: 'R2行政實務3', fullTitle: '應機而動4AI攻略', shortTitle: '應機而動4AI攻略', mapLabel: '應機而動4AI攻略' },
  { code: 'R2-4', box: [254, 379, 361, 485], fullName: 'R2行政實務4', fullTitle: '清淨慧行探險站 —\n智慧出坡與管理', shortTitle: '清淨慧行探險站', mapLabel: '清淨慧行探險站' },
  { code: 'R2-5', box: [362, 379, 469, 485], fullName: 'R2行政實務5', fullTitle: '機動組經驗主義的困境突破', shortTitle: '機動組經驗主義的困境突破', mapLabel: '機動組經驗主義的困境突破' },
  { code: 'R2-6', box: [510, 379, 616, 485], fullName: 'R2行政實務6', fullTitle: '「清」出新高度\n「潔」伴同行', shortTitle: '「清」出新高度 「潔」伴同行', mapLabel: '「清」出新高度「潔」伴同行' },

  { code: 'R3-1', box: [510, 271, 616, 378], fullName: 'R3禪修班實務1', fullTitle: '禪修班組織靈活優化 —\n學務組建立', shortTitle: '禪修班組織靈活優化', mapLabel: '禪修班組織靈活優化' },
  { code: 'R3-2', box: [362, 271, 469, 378], fullName: 'R3禪修班實務2', fullTitle: 'AI超級大腦養成所 —\n從個人效率到團隊升級', shortTitle: 'AI超級大腦養成所', mapLabel: 'AI超級大腦養成所' },
  { code: 'R3-3', box: [254, 271, 361, 378], fullName: 'R3禪修班實務3', fullTitle: '打破班級界線的隔閡', shortTitle: '打破班級界線的隔閡', mapLabel: '打破班級界線的隔閡' },
  { code: 'R3-4', box: [105, 271, 213, 378], fullName: 'R3禪修班實務4', fullTitle: '學長茶餐廳 —\n走進學長角色 體驗圍桌活動', shortTitle: '學長茶餐廳', mapLabel: '學長茶餐廳' },
  { code: 'R3-5', box: [105, 82, 213, 189], fullName: 'R3禪修班實務5', fullTitle: '學員長解憂雜貨舖 —\n「為什麼我越說、大家越安靜?」', shortTitle: '學員長解憂雜貨舖', mapLabel: '學員長解憂雜貨舖' },
  { code: 'R3-6', box: [284, 82, 392, 189], fullName: 'R3禪修班實務6', fullTitle: '出坡姿勢診療室', shortTitle: '出坡姿勢診療室', mapLabel: '出坡姿勢診療室' },

  { code: 'R4-1', box: [904, 82, 1010, 189], fullName: 'R4兒青推廣1', fullTitle: '星心之城 —\n實踐三環一體.成果展', shortTitle: '星心之城成果展', mapLabel: '星心之城成果展' },
  { code: 'R4-2', box: [796, 82, 902, 189], fullName: 'R4兒青推廣2', fullTitle: '校園弘法實務分享', shortTitle: '校園弘法實務分享', mapLabel: '校園弘法實務分享' },
  { code: 'R4-3', box: [648, 82, 754, 189], fullName: 'R4兒青推廣3', fullTitle: '學佛青年的凝聚、深耕與傳承', shortTitle: '學佛青年的凝聚、深耕與傳承', mapLabel: '學佛青年的凝聚、深耕與傳承' },
  { code: 'R4-4', box: [539, 82, 646, 189], fullName: 'R4兒青推廣4', fullTitle: '小護法養成記', shortTitle: '小護法養成記', mapLabel: '小護法養成記' },
  { code: 'R4-5', box: [394, 82, 500, 189], fullName: 'R4兒青推廣5', fullTitle: '小菩提育苗園 —\n教案互動室', shortTitle: '小菩提育苗園', mapLabel: '小菩提育苗園' },

  { code: 'R5-1', box: [873, 379, 980, 485], fullName: 'R5護法會深耕1', fullTitle: '承先啟後 正法久住 —\n新世代弘法的時代適應之道', shortTitle: '承先啟後 正法久住', mapLabel: '承先啟後正法久住' },
  { code: 'R5-2', box: [765, 379, 872, 485], fullName: 'R5護法會深耕2', fullTitle: '慧眼識英雄 —\n人才的選用育留', shortTitle: '慧眼識英雄', mapLabel: '慧眼識英雄' },
  { code: 'R5-3', box: [617, 379, 723, 485], fullName: 'R5護法會深耕3', fullTitle: '從「資深」到「新生」—\n打造跨世代的護法團隊', shortTitle: '從「資深」到「新生」', mapLabel: '從「資深」到「新生」' },
  { code: 'R5-4', box: [617, 271, 723, 378], fullName: 'R5護法會深耕4', fullTitle: '跨越障礙，弘法無礙', shortTitle: '跨越障礙，弘法無礙', mapLabel: '跨越障礙，弘法無礙' },
  { code: 'R5-5', box: [765, 271, 872, 378], fullName: 'R5護法會深耕5', fullTitle: '來來來的N次方 —\n自發性團隊的運轉心法', shortTitle: '自發性團隊的運轉心法', mapLabel: '自發性團隊的運轉心法' },
  { code: 'R5-6', box: [873, 271, 980, 378], fullName: 'R5護法會深耕6', fullTitle: '般若叮叮車：彼此照亮的旅程 —\n以「和合」引領護法團隊', shortTitle: '般若叮叮車', mapLabel: '般若叮叮車' },
]

export const marketMapBooths = rawBooths.map((booth) => {
  const region = booth.code.split('-')[0] // 'R1-5' -> 'R1'
  const half = BOOTH_GAP / 2
  // 四邊各內縮半個間距，讓相鄰色塊之間統一留出 BOOTH_GAP 的視覺間隙
  const x1 = booth.box[0] + half
  const y1 = booth.box[1] + half
  const x2 = booth.box[2] - half
  const y2 = booth.box[3] - half
  return {
    ...booth,
    region,
    // 全稱旁邊已經有分類代碼（如 R1-1）顯示英文/數字，這裡只保留中文字（例如 'R1接待實務1' -> '接待實務'）
    fullName: booth.fullName.replace(/^[A-Za-z0-9]+|[A-Za-z0-9]+$/g, ''),
    color: REGION_COLORS[region],
    // 轉成百分比定位，響應式容器下不需要依賴原圖絕對尺寸
    style: {
      left: `${(x1 / MAP_IMAGE_WIDTH) * 100}%`,
      top: `${(y1 / MAP_IMAGE_HEIGHT) * 100}%`,
      width: `${((x2 - x1) / MAP_IMAGE_WIDTH) * 100}%`,
      height: `${((y2 - y1) / MAP_IMAGE_HEIGHT) * 100}%`,
    },
  }
})

// 純文字標籤（出入口等指示文字）：無色塊、不可點擊，僅以文字定位於地圖上
// point: [x, y] 為文字中心點座標
const rawMapLabels = [
  { text: '參觀\n入口', point: [1040, 380], boxed: true },
  { text: 'A入口', point: [1031, 240] },
  { text: 'B入口', point: [1029, 526] },
  { text: '東1出口', point: [252, 32] },
  { text: '東2出口', point: [773, 34] },
  { text: '西1出口', point: [244, 742] },
  { text: '西2出口', point: [775, 741] },
]

export const marketMapLabels = rawMapLabels.map((label) => {
  const [x, y] = label.point
  return {
    ...label,
    style: {
      left: `${(x / MAP_IMAGE_WIDTH) * 100}%`,
      top: `${(y / MAP_IMAGE_HEIGHT) * 100}%`,
    },
  }
})
